import { useDispatch, useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import AppActions from 'app/shared/flux/actions/AppActions';
import {
  emitTrackBuildingPayPerLinkClickEvent,
  emitTrackLowerPpcClickEvent,
} from 'app/shared/models/Clickstream/HdpClickstreamEvents';
import { ReadMoreButton } from '../../../ui/ReadMoreButton';
import { BuildingWebsiteLink } from '../../../ui/BuildingWebsiteLink';
import { container, websiteContainer } from './aboutTheBuildingModule.styles';

export const AboutTheBuildingModule = () => {
  const dispatch = useDispatch();
  const currentListing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);

  const fullDescription = currentListing?.details?.fullDescription;
  const websiteUrl = currentListing?.details?.webSite;

  if (!fullDescription && !websiteUrl) {
    return null;
  }

  const displayName = currentListing?.displayName;
  const websiteLinkText = displayName ? `Visit ${displayName} website` : 'Visit property website';
  const websiteAriaLabel = displayName ? `Visit ${displayName} website` : `Visit property website: ${websiteUrl}`;

  const handleWebsiteClick = () => {
    dispatch(AppActions.sendEventToApi('building_website_visited', null));
    if (currentListing?.maloneLotIdEncoded) {
      dispatch(AppActions.sendEventToApi('building_website_clicked', currentListing.maloneLotIdEncoded));
    }
    emitTrackLowerPpcClickEvent({ triggerLocation: 'home_details' });
    emitTrackBuildingPayPerLinkClickEvent({
      triggerObject: 'home_details_component|property_details',
      triggerLocation: 'home_details',
    });
  };

  return (
    <div className={container}>
      {fullDescription && (
        <ReadMoreButton
          content={fullDescription}
          maxTruncatedLength={150}
          readMoreText="Read more"
          readLessText="Read less"
          aria-label="Building description"
        />
      )}

      {websiteUrl && (
        <div className={websiteContainer}>
          <BuildingWebsiteLink
            websiteUrl={websiteUrl}
            linkText={websiteLinkText}
            ariaLabel={websiteAriaLabel}
            onClick={handleWebsiteClick}
          />
        </div>
      )}
    </div>
  );
};
